/**
 * ParkingRadiusLegend - Легенда радиусов парковок
 *
 * Мигрирована на новую систему легенд (Этап 2)
 * Использует LegendRenderer с типом RANGE
 */

import React from 'react';
import { t } from '@lingui/macro';
import { LegendRenderer } from '../../LegendRenderer';
import { PARKING_RADIUS_LEGEND } from '../../../constants/legends';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';

const ParkingRadiusLegendComponent = () => (
    <LegendRenderer config={PARKING_RADIUS_LEGEND} />
);

export const ParkingRadiusLegend = withDisplayedLayersCheck(
    ParkingRadiusLegendComponent,
    t`Парковки с радиусом_fin`
);
